import { render } from "./PagerTable.vue?vue&type=template&id=07f63bde"
import script from "./PagerTable.vue?vue&type=script&lang=js"
export * from "./PagerTable.vue?vue&type=script&lang=js"

import "./PagerTable.vue?vue&type=style&index=0&id=07f63bde&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__